import { render, staticRenderFns } from "./customer_main.vue?vue&type=template&id=05936248&scoped=true&"
import script from "./customer_main.vue?vue&type=script&lang=js&"
export * from "./customer_main.vue?vue&type=script&lang=js&"
import style0 from "./customer_main.vue?vue&type=style&index=0&id=05936248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05936248",
  null
  
)

export default component.exports